import * as React from 'react';
import { t } from 'ttag';
import Popup from '../shared_component/Popup';

type Props = { email: string | null };
const Success = ({ email }: Props) => {
  return (
    <Popup title={t`Unsubscribed successfully`}>
      <span>{t`${email} has been successfully unsubscribed from the list.`}</span>
      <br />
      <span>{t`You will no longer receive this type of email from us.`}</span>
    </Popup>
  );
};

export default Success;
